// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MaterialAttributeDimensionsQueryVariables = Types.Exact<{
  filter: Types.MaterialAttributeDimensionFilter;
}>;


export type MaterialAttributeDimensionsQuery = { __typename?: 'Query', materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> };

export type CreateDesignPackagePlaceholderTliMutationVariables = Types.Exact<{
  input: Types.CreateDesignPackagePlaceholderTliInput;
}>;


export type CreateDesignPackagePlaceholderTliMutation = { __typename?: 'Mutation', createDesignPackagePlaceholderTli: { __typename?: 'CreateDesignPackagePlaceholderTliResult', placeholderTli: { __typename?: 'TakeoffLineItem', id: string, slot: { __typename?: 'ItemSlot', id: string } }, readyPlanAggregateVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string } } };


export const MaterialAttributeDimensionsDocument = gql`
    query MaterialAttributeDimensions($filter: MaterialAttributeDimensionFilter!) {
  materialAttributeDimensions(filter: $filter) {
    id
    name
    values {
      id
      textValue
    }
  }
}
    `;

/**
 * __useMaterialAttributeDimensionsQuery__
 *
 * To run a query within a React component, call `useMaterialAttributeDimensionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialAttributeDimensionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialAttributeDimensionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMaterialAttributeDimensionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MaterialAttributeDimensionsQuery, MaterialAttributeDimensionsQueryVariables> & ({ variables: MaterialAttributeDimensionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MaterialAttributeDimensionsQuery, MaterialAttributeDimensionsQueryVariables>(MaterialAttributeDimensionsDocument, options);
      }
export function useMaterialAttributeDimensionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialAttributeDimensionsQuery, MaterialAttributeDimensionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MaterialAttributeDimensionsQuery, MaterialAttributeDimensionsQueryVariables>(MaterialAttributeDimensionsDocument, options);
        }
// @ts-ignore
export function useMaterialAttributeDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MaterialAttributeDimensionsQuery, MaterialAttributeDimensionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialAttributeDimensionsQuery, MaterialAttributeDimensionsQueryVariables>;
export function useMaterialAttributeDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialAttributeDimensionsQuery, MaterialAttributeDimensionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MaterialAttributeDimensionsQuery | undefined, MaterialAttributeDimensionsQueryVariables>;
export function useMaterialAttributeDimensionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MaterialAttributeDimensionsQuery, MaterialAttributeDimensionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MaterialAttributeDimensionsQuery, MaterialAttributeDimensionsQueryVariables>(MaterialAttributeDimensionsDocument, options);
        }
export type MaterialAttributeDimensionsQueryHookResult = ReturnType<typeof useMaterialAttributeDimensionsQuery>;
export type MaterialAttributeDimensionsLazyQueryHookResult = ReturnType<typeof useMaterialAttributeDimensionsLazyQuery>;
export type MaterialAttributeDimensionsSuspenseQueryHookResult = ReturnType<typeof useMaterialAttributeDimensionsSuspenseQuery>;
export type MaterialAttributeDimensionsQueryResult = Apollo.QueryResult<MaterialAttributeDimensionsQuery, MaterialAttributeDimensionsQueryVariables>;
export const CreateDesignPackagePlaceholderTliDocument = gql`
    mutation CreateDesignPackagePlaceholderTli($input: CreateDesignPackagePlaceholderTliInput!) {
  createDesignPackagePlaceholderTli(input: $input) {
    placeholderTli {
      id
      slot {
        id
      }
    }
    readyPlanAggregateVersion {
      id
    }
  }
}
    `;
export type CreateDesignPackagePlaceholderTliMutationFn = Apollo.MutationFunction<CreateDesignPackagePlaceholderTliMutation, CreateDesignPackagePlaceholderTliMutationVariables>;

/**
 * __useCreateDesignPackagePlaceholderTliMutation__
 *
 * To run a mutation, you first call `useCreateDesignPackagePlaceholderTliMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDesignPackagePlaceholderTliMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDesignPackagePlaceholderTliMutation, { data, loading, error }] = useCreateDesignPackagePlaceholderTliMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDesignPackagePlaceholderTliMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDesignPackagePlaceholderTliMutation, CreateDesignPackagePlaceholderTliMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDesignPackagePlaceholderTliMutation, CreateDesignPackagePlaceholderTliMutationVariables>(CreateDesignPackagePlaceholderTliDocument, options);
      }
export type CreateDesignPackagePlaceholderTliMutationHookResult = ReturnType<typeof useCreateDesignPackagePlaceholderTliMutation>;
export type CreateDesignPackagePlaceholderTliMutationResult = Apollo.MutationResult<CreateDesignPackagePlaceholderTliMutation>;
export type CreateDesignPackagePlaceholderTliMutationOptions = Apollo.BaseMutationOptions<CreateDesignPackagePlaceholderTliMutation, CreateDesignPackagePlaceholderTliMutationVariables>;